import { Link } from "react-router-dom";
import { Bell, Sparkles } from "lucide-react";

/**
 * Notifications placeholder (Phase 20A ships an empty state; wire real events in 20B).
 */
export default function PowerNotifications() {
  return (
    <div data-testid="power-notifications" className="pb-6">
      <div className="bg-white rounded-3xl border border-[#E4EAF3] p-8 sm:p-12 text-center shadow-sm">
        <div className="w-16 h-16 rounded-full bg-[#1E88FF]/10 text-[#1E88FF] flex items-center justify-center mx-auto mb-4">
          <Bell className="w-8 h-8" />
        </div>
        <h1 className="font-black text-2xl text-[#0A1A2F]">All quiet — for now.</h1>
        <p className="text-[#0A1A2F]/60 text-sm mt-1 max-w-sm mx-auto">
          When your petitions gain signatures, hit milestones, or someone follows you — you'll see it here.
        </p>
        <div className="mt-5 flex flex-wrap gap-2 justify-center">
          <Link to="/power/create" className="inline-flex items-center gap-2 bg-gradient-to-r from-[#1E88FF] to-[#0A1A2F] text-white font-bold px-5 py-2.5 rounded-full">
            <Sparkles className="w-4 h-4" /> Start a petition
          </Link>
          <Link to="/power/explore" className="inline-flex items-center gap-2 bg-white border border-[#E4EAF3] text-[#0A1A2F] font-semibold px-5 py-2.5 rounded-full hover:border-[#1E88FF]">
            Explore & sign
          </Link>
        </div>
      </div>
    </div>
  );
}
